import {DependencyInjectId} from '@@/package/const/DependencyInjectId';
import HttpClient from '@@/package/network/HttpClient';
import {type ApplicationContextInterface} from '@@/package/application/applicationContext';
import {type AxiosResponse} from 'axios';
import type CustomResponse from '~~/package/types/ResponseType';
import {AssessmentSummaryModel} from '~~/package/mapper/report/model/assessment/AssessmentSummaryModel';
import {ReportDomainType} from '~~/package/mapper/report/model/ReportDomainType';
import type {SkillSummaryModel} from '~~/package/mapper/report/model/assessment/SkillSummaryModel';
import type {TrackSummaryModel} from '~~/package/mapper/report/model/assessment/TrackSummaryModel';
import {
  ProSkillManagerCandidateOrderType
} from '~~/package/mapper/proSkillManager/model/candidate/ProSkillManagerCandidateOrderType';
import {
  AssessmentCandidateSummaryModel
} from '~~/package/mapper/report/model/candidate/AssessmentCandidateSummaryModel';
import {TrackCandidateSummaryModel} from '~~/package/mapper/report/model/candidate/TrackCandidateSummaryModel';
import type {CandidateActionAnalysisModel} from '~~/package/mapper/report/model/candidate/CandidateActionAnalysisModel';


export default class ReportApi {

  protected http: HttpClient;

  constructor(context: ApplicationContextInterface) {
    this.http = context.getService<HttpClient>(DependencyInjectId.HttpClient);
  }

  public getReportAssessmentSummary(domainType: ReportDomainType, domainId: number): Promise<AxiosResponse<CustomResponse<AssessmentSummaryModel>>> {
    return this.http.get<AxiosResponse<CustomResponse<AssessmentSummaryModel>>>(`/reports/summary`, { domainType, domainId }, true);
  }

  public getReportTrackSummary(domainType: ReportDomainType, domainId: number, sort?: string): Promise<AxiosResponse<CustomResponse<TrackSummaryModel[]>>> {
    return this.http.get<AxiosResponse<CustomResponse<TrackSummaryModel[]>>>(`/reports/summary/track`, { domainType, domainId, sort }, true);
  }

  public getReportSkillSummary(lang: string, domainType: ReportDomainType, domainId: number, sort?: string): Promise<AxiosResponse<CustomResponse<SkillSummaryModel[]>>> {
    return this.http.get<AxiosResponse<CustomResponse<SkillSummaryModel[]>>>(`/reports/summary/skill`, { domainType, domainId, sort }, true, lang);
  }

  public getReportCandidateAssessmentSummary(userUUID: string, domainType: ReportDomainType, domainId: number): Promise<AxiosResponse<CustomResponse<AssessmentCandidateSummaryModel>>> {
    return this.http.get<AxiosResponse<CustomResponse<AssessmentCandidateSummaryModel>>>(`/reports/candidates/${userUUID}/summary`, { domainType, domainId }, true);
  }

  public getReportCandidateTrackSummary(userUUID: string, domainType: ReportDomainType, domainId: number): Promise<AxiosResponse<CustomResponse<TrackCandidateSummaryModel[]>>> {
    return this.http.get<AxiosResponse<CustomResponse<TrackCandidateSummaryModel[]>>>(`/reports/candidates/${userUUID}/summary/track`, { domainType, domainId }, true);
  }

  public getReportCandidateSkillSummary(lang: string, userUUID: string, domainType: ReportDomainType, domainId: number, sort?: string): Promise<AxiosResponse<CustomResponse<SkillSummaryModel[]>>> {
    return this.http.get<AxiosResponse<CustomResponse<SkillSummaryModel[]>>>(`/reports/candidates/${userUUID}/summary/skill`, { domainType, domainId, sort }, true, lang);
  }

  public getReportCandidateActionAnalysis(userUUID: string, domainType: ReportDomainType, domainId: number): Promise<AxiosResponse<CustomResponse<CandidateActionAnalysisModel>>> {
    return this.http.get<AxiosResponse<CustomResponse<CandidateActionAnalysisModel>>>(`/reports/candidates/${userUUID}/actions`, { domainType, domainId }, true);
  }

  public submitReportExport(email: string, url: string, domainType: ReportDomainType, domainId: number): Promise<AxiosResponse<CustomResponse<boolean>>> {
    return this.http.post<AxiosResponse<CustomResponse<boolean>>, {}>(`/reports/export`, { email, url, domainType, domainId }, true);
  }

  public submitBulkReportExport(email: string, domainType: ReportDomainType, domainId: number): Promise<AxiosResponse<CustomResponse<boolean>>> {
    return this.http.post<AxiosResponse<CustomResponse<boolean>>, {}>(`/reports/export/bulk`, { email, domainType, domainId }, true);
  }
}
